/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import foldericon from "../../images/folder.svg";
import ProjectSelect from "components/Select/Project";
import AddJobTitle from "./AddJobTitle";
import AddKeywords from "./AddKeywords";
import AddSkills from "./AddSkills";
import WorkExperience from "./WorkExperience";
import SelectIndustryComponent from "./SelectIndustryComponent";
import SelectCompanies from "./SelectCompanies";
import IncludeLocation from "./IncludeLocation";
import ExcludeLocationComponent from "./ExcludeLocationComponent";
import EducationComponent from "./EducationComponent";
// import CertificationComponent from "./CertificationComponent";
import InsertProjectInformationForm from "./InsertProjectInformationForm";
import SearchInitiatorFilter from "components/AISeearchMain/SearchInitiatorFilters";
import { addFullName } from "store/slices/searcSlice";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import SelectAgencies from "./SelectAgencies";
import StickyBox from "react-sticky-box";
import { APP_CONSTANTS } from "components/constants/AppConstants";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import { Input } from "antd";
import { useSelector } from "react-redux";

function AIfilter({
  isModal,
  onSearch,
  isFilterQuery,
  setIsSearchLoading,
  runFrom,
  isSearchResult,
}: any) {
  const dispatch = useAppDispatch();
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      paddingLeft: "25px",
      borderColor: "#E9D7FE",
      background: "#F9F5FF",
      outline: "none",
      boxShadow: "none",
    }),
    option: (provided: any) => ({
      ...provided,
      color: "#101828",
    }),
  };
  const [industryChangeTrigger, setIndustryChangeTrigger] = useState<null | number>(null);
  const industryType = useAppSelector((state) => state.search.industry_type);
  const industry = useAppSelector((state) => state.search.industries);
  const isNamedSearch = useSelector((state: any) => state.search.isNamedSearch);
  const searchName = useSelector((state: any) => state.search.full_name);
  const [jobTitleValue, setJobTitleValue] = useState<string[]>([]);
  const queryParams = new URLSearchParams(location.search);
  const searchId = queryParams.get("searchId");
  const handleNameChange = (value: string) => {
    dispatch(addFullName(value));
  };
  const onChangeIndustry = (value: string) => {
    industryChangeTrigger != null ? setIndustryChangeTrigger(industryChangeTrigger + 1) : setIndustryChangeTrigger(0);

  };

  // useEffect(() => {
  //   console.log("Job Title Value : ", jobTitleValue);
  // }, [jobTitleValue]);

  return (
    <div>
      <StickyBox
        offsetTop={0}
        offsetBottom={20}
        className={`z-10 ${isSearchResult ? "hidden" : ""}`}
      >
        <div
          className={`py-2 border-main-border border-b flex p-4 bg-white items-center justify-between`}
        >
          <div className="flex gap-2 items-center flex-1">
            {isNamedSearch ? (
              <p className="font-inter text-xl font-bold mb-0 flex item-center">Search By Name </p>
            ) : (
              <>
                <p className="font-inter text-xl font-bold mb-0 flex item-center">
                  Select Project{" "}
                </p>
                <div className="relative flex-1 select-project-wrapper">
                  <ProjectSelect
                    styles={customStyles}
                    onSelect={(selectedOption: any) => {
                      return null;
                    }}
                    isModal={isModal}
                  ></ProjectSelect>
                  <img
                    className="absolute top-1/2 -translate-y-1/2 left-2.5"
                    src={foldericon}
                    alt="Folder Icon"
                  />
                </div>
              </>
            )}
          </div>
          <div className="flex items-center justify-center gap-3">
            {/* <button className="py-2.5 px-3.5 border-primary-border border border-1 shadow-sm flex items-center gap-1 rounded-md font-semibold  text-sm text-text-secondary">
            <img src={closebuttonicon} />
          </button>{" "} */}
            {/* <button className="relative overflow-hidden font-semibold  text-sm text-white rounded-md py-2.5 px-3.5 shadow-md bg-[#845dda] border border-[#7F56D9] after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-md after:border after:border-[#8e69dd]">
            Run Your Search
          </button> */}
            {/* <SearchInitiatorFilter
              setIsSearchLoading={setIsSearchLoading}
              isModal={isModal}
              onSearch={onSearch}
              isFilterQuery={isFilterQuery}
              runFrom={runFrom}
            ></SearchInitiatorFilter> */}
          </div>
        </div>
      </StickyBox>
      {/* <TextAreaComponent></TextAreaComponent>
      <KeywordSuggester jobTitles={["CTO"]}></KeywordSuggester> */}

      <div>
        {/* <div className="py-6 px-5 xl:px-8 bg-white flex gap-5 xl:gap-12">
          <div className="w-1/3">
            <p className="text-text-secondary font-semibold ">Insert Information From:</p>
            <p className="text-text-quaternary mt-3 text-sm font-normal">
              Information will be automatically filled in from the source you select
            </p>
          </div>

          <div className="w-3/4">
            <div className="flex w-full  gap-6">
              <div className="flex-1">
                <label className="text-text-secondary font-medium text-sm cursor-pointer flex items-center">
                  Project
                  <div className="relative group">
                    <img src={helpicon} alt="Help Icon" className="ps-1 cursor-pointer" />
                    <div className="absolute bottom-full mb-2 hidden group-hover:block p-2 bg-tooltip-bg text-white text-xs rounded whitespace-nowrap left-1/2 transform -translate-x-1/2 shadow-lg">
                      This is a tooltip
                    </div>
                  </div>
                </label>
                <div className="mt-1.5 SelectProject-input">
                  <SearchableDropdownWithLabel
                    options={options}
                    label="name"
                    id="id"
                    selectedVal={value}
                    handleChange={(val: any) => setValue(val)}
                  />
                </div>
              </div>

              <div className="flex-1">
                <label className="text-text-secondary font-medium text-sm cursor-pointer flex items-center">
                  Recent search
                  <div className="relative group">
                    <img src={helpicon} alt="Help Icon" className="ps-1 cursor-pointer" />
                    <div className="absolute bottom-full mb-2 hidden group-hover:block p-2 bg-tooltip-bg text-white text-xs rounded whitespace-nowrap left-1/2 transform -translate-x-1/2 shadow-lg">
                      This is a tooltip
                    </div>
                  </div>
                </label>
                <div className="mt-1.5 SelectProject-input">
                  <SearchableDropdownWithLabel
                    options={optionsSelectRecent}
                    label="name"
                    id="id"
                    selectedVal={SelectRecent}
                    handleChange={(val: any) => setSelectRecent(val)}
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center w-full mt-6 ">
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full  border-2 border-main-border border-solid rounded-lg cursor-pointer bg-white  hover:border-primary py-4"
              >
                <div className="flex flex-col items-center justify-center  ">
                  <div className="p-2.5 shadow-sm mb-4 border-solid border-main-border border rounded-md">
                    <svg
                      className="w-5 h-5  text-text-secondary"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                  </div>
                  <p className="mb-2 text-sm text-text-tertiary font-normal">
                    <span className="font-semibold text-primary">Click to upload</span> or drag and
                    drop
                  </p>
                  <p className="text-xs text-text-tertiary">DOC, DOX, PDF or Pages (max. 1Mb)</p>
                </div>
                <input id="dropzone-file" type="file" className="hidden" />
              </label>
            </div>
          </div>
        </div> */}

        {isNamedSearch && (
          <div className={`py-6 px-5 xl:px-8 bg-bg-secondary flex gap-5 xl:gap-12`} id="name">
            <div className="w-1/4">
              <SectionTitleAndDescription
                title="Add Search Name"
                isRequiredSection={false}
                isHelpInfoReq={false}
              />
            </div>
            <div className="w-3/4">
              <Input
                type="text"
                value={searchName}
                onChange={(e) => handleNameChange(e.target.value)}
                size="large"
                placeholder="Name"
              />
            </div>
          </div>
        )}
        {isNamedSearch ? null : (
          <>
            {!isModal && (
              <div
                className={`py-6 px-5 xl:px-8 bg-bg-secondary flex gap-5 xl:gap-12 border-b border-dashed ${isModal ? "border-b border-dashed" : ""
                  }`}
                id="project"
              >
                <InsertProjectInformationForm />
              </div>
            )}

            <div
              className={`py-6 px-5 xl:px-8 bg-white flex gap-5 xl:gap-12 border-b border-dashed ${isModal ? "border-b border-dashed" : ""
                }`}
              id="job_titles"
            >
              <AddJobTitle
                setJobTitleValue={setJobTitleValue}
                isModal={isModal}
                searchId={searchId}
              />
            </div>

            <div
              className={`py-6 px-5 xl:px-8 bg-bg-secondary flex gap-5 xl:gap-12 border-b border-dashed ${isModal ? "border-b border-dashed" : ""
                }`}
              id="keywords"
            >
              <AddKeywords jobTitleValue={jobTitleValue} isModal={isModal} searchId={searchId} />
            </div>
            <div
              className={`py-6 px-5 xl:px-8 bg-white flex gap-5 xl:gap-12 border-b border-dashed ${isModal ? "border-b border-dashed" : ""
                }`}
              id="work_experiences"
            >
              <WorkExperience isModal={isModal} searchId={searchId} />
            </div>

            {/* <div
          className={`py-6 px-5 xl:px-8 bg-white flex gap-5 xl:gap-12 mt-8 ${isModal ? "border-b border-dashed" : ""}`}
          id="skills"
        >
          <AddSkills />
        </div> */}

            <div className="py-6 px-5 xl:px-8 bg-bg-secondary">
              <div className="flex gap-5 xl:gap-12 xl:py-12 py-9 border-b border-main-border border-dashed">
                <SelectIndustryComponent onChangeIndustry={onChangeIndustry} />
              </div>

              {industryType.indexOf(APP_CONSTANTS.marketing_agencies) > -1 ||
                industryType.indexOf("Marketing and Advertising") > -1 ||
                industryType.indexOf("Advertising Services") > -1 ||
                industry.indexOf(APP_CONSTANTS.marketing_agencies) > -1 ||
                industry.indexOf("Marketing and Advertising") > -1 ||
                industry.indexOf("Advertising Services") > -1 ||
                industryType.indexOf("martech") > -1 ||
                industryType.indexOf("Martech") > -1 ||
                industryType.indexOf("Adtech/Martech") > -1 ||
                industryType.indexOf("adTech") > -1 ||
                industryType.indexOf("Adtech") > -1 ||
                industry.indexOf("adTech") > -1 ||
                industry.indexOf("Adtech") > -1 ||
                industry.indexOf("Adtech/Martech") > -1 ||
                industry.indexOf("martech") > -1 ||
                industry.indexOf("Martech") > -1 ? (
                <div className="flex gap-5 xl:gap-12 xl:pt-12 pt-9 ">
                  <SelectAgencies industryChangeTrigger={industryChangeTrigger} />
                </div>
              ) : (
                <div className="flex gap-5 xl:gap-12 xl:pt-12 pt-9 ">
                  <SelectCompanies />
                </div>
              )}
            </div>
          </>
        )}

        <div
          className={`py-6 px-5 xl:px-8 bg-white border-t border-dashed border-b border-main-border ${isModal ? "border-t border-dashed" : ""
            }`}
          id="locations"
        >
          <div
            className={`flex gap-5 xl:gap-12 xl:pb-12 pb-9 ${isNamedSearch ? "" : "border-dashed border-b border-main-border"
              }`}
          >
            <IncludeLocation isModal={isModal} searchId={searchId} />
          </div>
          {isNamedSearch ? null : (
            <div className="flex gap-5 xl:gap-12 xl:pt-12 pt-9 ">
              <ExcludeLocationComponent isModal={isModal} searchId={searchId} />
            </div>
          )}
        </div>

        {isNamedSearch ? null : (
          <div
            className="py-6 px-5 xl:px-8 bg-bg-secondary border-dashed border-b border-main-border"
            id="education"
          >
            <div className={`flex gap-5 xl:gap-12 xl:py-12 py-9`}>
              <EducationComponent />
            </div>

            {/* <div className="flex gap-5 xl:gap-12 xl:py-12 py-9 ">
            <CertificationComponent />
          </div> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default AIfilter;
